import languages from './languages';
import type { Lucid } from '../../types/types';

/** Locates the correct language object from a potential languageId */
const getLanguageData = (languageKey: string, key: Lucid.I18n.LanguagesKeys): Lucid.I18n.Languages | undefined =>
  languages.find(language => language[key] === languageKey);

export default getLanguageData;
